exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src14910448/src/src/app/components/page-not-found/page-not-found.component.scss
// module id = ../../../../../src/app/components/page-not-found/page-not-found.component.scss
// module chunks = main